/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import SelectableRow from '../../../../client/js/components/selection/SelectableRow'
import { invoiceAmount } from '../../lib/common/amount.mjs'
import CustomerLink from '../customer/CustomerLink'
import Ref from '../Ref'
import InvoiceStatusBadge from './InvoiceStatusBadge'
import useInvoiceTypeOptions from './useInvoiceTypeOptions'
import { getEstateLink } from '../../lib/links/estateLinks'
import { Button, Table, Text } from '@mantine/core'
import AnchorLink from '../../../../client/js/components/AnchorLink'
import Amount from '../transaction/Amount'
import EstateInfoHoverCard from '../estate/EstateInfoHoverCard'

export type InvoiceListItemProps = {
  item: Invoice,
  itemLink: string
}

function InvoiceListItem (props: InvoiceListItemProps) {
  const { item, itemLink } = props
  const intl = useIntl()

  const invoiceTypeOptions = useInvoiceTypeOptions()
  const invoiceTypeLabel = useMemo(() => (
    invoiceTypeOptions.find((el) => el.value === item.type)?.label
  ), [invoiceTypeOptions, item.type])

  return (
    <SelectableRow value={item.id}>
      <Table.Td>
        <InvoiceStatusBadge invoice={item} />
      </Table.Td>
      <Table.Td>
        <AnchorLink to={itemLink.replace(/{id}/g, String(item.id))}>
          <Ref value={item.reference} />
        </AnchorLink>
        <Text size="xs" c="dimmed">
          {invoiceTypeLabel}
        </Text>
      </Table.Td>
      <Table.Td>
        {item.dueAt ? intl.formatDate(item.dueAt) : null}
      </Table.Td>
      <Table.Td ta="end">
        <Amount value={invoiceAmount(item.total)} inherit withCurrency />
      </Table.Td>
      <Table.Td>
        <CustomerLink customer={item.Customer} />
      </Table.Td>
      <Table.Td>
        <Ref mr="sm" value={item.Estate.reference} />
        <EstateInfoHoverCard estateId={item.estateId}>
          <span>
            <AnchorLink to={getEstateLink(item.estateId)}>
              {item.Estate.title}
            </AnchorLink>
          </span>
        </EstateInfoHoverCard>
      </Table.Td>
      <Table.Td ta="end">
        <Button
          to={`/api/invoices/${item.id}/file`}
          rel="noopener"
          size="xs"
          component={AnchorLink}
          target="_blank"
        >
          <FontAwesomeIcon icon={faDownload} />
        </Button>
      </Table.Td>
    </SelectableRow>
  )
}

export default InvoiceListItem
